import { render, staticRenderFns } from "./new-friends.vue?vue&type=template&id=3e785c1a"
import script from "./new-friends.vue?vue&type=script&lang=js"
export * from "./new-friends.vue?vue&type=script&lang=js"
import style0 from "./new-friends.vue?vue&type=style&index=0&id=3e785c1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports